import * as React from 'react';
import { compose, pure, withHandlers, withPropsOnChange, withState } from 'recompose';
import { createStyles, withStyles } from '@material-ui/styles';
import MuiTextField from '@material-ui/core/TextField';
import cn from 'classnames';
import { toCssValue } from '@topconagriculture/theme';
import { FontIcon } from '../../FontIcon';
import debounce from 'lodash/debounce';
const styles = (theme) => createStyles({
    search: {
        position: 'relative',
        display: 'flex',
        width: 680,
        height: 60,
        boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.24), 0 0 8px 0 rgba(0, 0, 0, 0.12)',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.color.background.light,
        borderRadius: theme.common.borderRadius.default,
    },
    root: {
        height: '100%',
        width: '100%',
        backgroundColor: theme.color.background.light,
    },
    inputTextFilter: {
        height: '100%',
        width: '100%',
        padding: 0,
        paddingLeft: 20,
        color: theme.color.grey.dark,
        fontSize: theme.font.size.big,
        '&:after, &:before': {
            content: 'none',
        },
        '&::-webkit-input-placeholder': {
            color: theme.color.input.placeholder,
            opacity: 1,
        },
        '&::-moz-placeholder': {
            color: theme.color.input.placeholder,
            opacity: 1,
        },
        '&:-ms-input-placeholder': {
            color: theme.color.input.placeholder,
            opacity: 1,
        },
        '&:-moz-placeholder': {
            color: theme.color.input.placeholder,
            opacity: 1,
        },
    },
    buttonSearch: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexBasis: 120,
        minWidth: 120,
        height: '100%',
        color: theme.color.font.light,
        textAlign: 'center',
        backgroundColor: theme.color.primary.main,
        borderRadius: toCssValue([0, 5, 5, 0]),
        '&:hover': {
            backgroundColor: theme.color.primary.dark,
            cursor: 'pointer',
        },
        '&:active': {
            backgroundColor: theme.color.primary.darkest,
            cursor: 'pointer',
        },
    },
});
const AppSearchInput = (props) => {
    const { classes, className: classNameProp, theme, handleChange, placeholder, className, value, resetField, testId = 'AppSearchInput', } = props;
    const currentIcon = value ? 'close' : 'search';
    const inputProps = {
        inputProps: { className: classes.inputTextFilter },
        disableUnderline: true,
        classes: { root: classes.root },
    };
    return (React.createElement("div", { className: cn(classes.search, classNameProp) },
        React.createElement(FontIcon, { size: 20, marginLeft: 15, top: 3, color: theme.color.font.dark, iconName: 'search' }),
        React.createElement(MuiTextField, { InputProps: inputProps, placeholder: placeholder, className: cn(classes.root, className), onChange: (e) => handleChange(e.target.value), value: value, "data-testid": testId }),
        React.createElement("div", { className: classes.buttonSearch, onClick: resetField, "data-testid": `${testId}-reset` },
            React.createElement(FontIcon, { size: 30, top: 5, iconName: currentIcon }))));
};
const ComposedAppSearchInput = compose(withStyles(styles, { withTheme: true }), pure, withState('value', 'setValue', (props) => (props.input && props.input.value) || ''), withPropsOnChange((props, nextProps) => props.input.onChange !== nextProps.input.onChange, (props) => ({
    debouncedOnChange: debounce((val) => {
        props.input.onChange(val);
    }, props.debounceTime),
})), withHandlers({
    handleChange: (props) => (val) => {
        props.setValue(val);
        if (!props.debounceTime) {
            props.input.onChange(val);
        }
        else {
            props.debouncedOnChange(val);
        }
    },
    resetField: (props) => () => {
        props.setValue('');
        props.input.onChange('');
    },
}))(AppSearchInput);
ComposedAppSearchInput.displayName = 'AppSearchInput';
export default ComposedAppSearchInput;
//# sourceMappingURL=AppSearchInput.js.map